module.exports = __webpack_public_path__ + "static/media/logo_black.314db861.png";